import React, { useCallback } from "react";
import CbeResults from "./CbeResults";
import CbeHealthStatusDisplay from "./CbeHealthStatusDisplay";
import { CanonicalBusinessEvent } from "../../types";
import VersionSelector from "../common/VersionSelector";

interface Props {
  cbeData: CanonicalBusinessEvent[];
  onVersionChange: (index: number) => void;
}

export default function CbeVersionSelector(props: Props) {
  const { cbeData, onVersionChange } = props;

  const handleVersionChange = useCallback(
    (index: number) => {
      onVersionChange(index);
    },
    [onVersionChange]
  );

  const renderTabLabel = useCallback(
    (version: number, cbesForVersion: CanonicalBusinessEvent[]) => {
      return (
        <CbeHealthStatusDisplay
          name="Version"
          events={cbesForVersion}
          value={version.toString()}
        />
      );
    },
    []
  );

  const renderTabContent = useCallback(
    (cbesForVersion: CanonicalBusinessEvent[]) => {
      return <CbeResults cbeData={cbesForVersion} />;
    },
    []
  );

  return (
    <VersionSelector
      data={cbeData}
      getVersion={(cbe) => cbe.lockVersion}
      renderTabLabel={renderTabLabel}
      renderTabContent={renderTabContent}
      onVersionChange={handleVersionChange}
    />
  );
}
